import { Command, Folder, FileText } from 'lucide-react'

interface CommandPaletteProps {
  isOpen: boolean
  onClose: () => void
  onCreateFolder: () => void
  onCreateFile: () => void
}

// The "+ New" quick-action palette (Ctrl/Cmd+K). Presentational — the parent
// owns the open state and the actual create-modal toggles.
export function CommandPalette({ isOpen, onClose, onCreateFolder, onCreateFile }: CommandPaletteProps) {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/80 backdrop-blur-sm pt-32"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl rounded-2xl border border-white/10 bg-black/90 shadow-2xl backdrop-blur-xl animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-white/10 p-4">
          <div className="flex items-center gap-3">
            <Command className="h-5 w-5 text-dark-400" />
            <input
              type="text"
              placeholder="Type a command or search..."
              className="flex-1 bg-transparent text-lg text-white placeholder-dark-400 outline-none"
              autoFocus
            />
          </div>
        </div>
        <div className="max-h-96 overflow-y-auto p-2">
          {/* Upload intentionally omitted — dedicated Upload button lives next to
              this menu in the toolbar, so having it here too was redundant. */}
          <button
            onClick={onCreateFolder}
            className="flex w-full items-center gap-3 rounded-lg p-3 text-left transition-colors hover:bg-white/5"
          >
            <Folder className="h-5 w-5 text-blue-400" />
            <div>
              <p className="text-white font-medium">Create Folder</p>
              <p className="text-xs text-dark-400">Create a new folder</p>
            </div>
          </button>
          <button
            onClick={onCreateFile}
            className="flex w-full items-center gap-3 rounded-lg p-3 text-left transition-colors hover:bg-white/5"
          >
            <FileText className="h-5 w-5 text-green-400" />
            <div>
              <p className="text-white font-medium">Create File</p>
              <p className="text-xs text-dark-400">Create a new file</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}
